import { getRgObjectsOfType as g, RG_TYPE as c } from "@project-rouge/rg-core";
import { mapRgObjectsByLevels as p } from "../../utils/rg-util/index6.js";
import { getArea as o } from "./index3.js";
const y = (e, r, i) => {
  e = Array.isArray(e) ? e : [e];
  const a = g(e, c.Building);
  if (a.length <= 0)
    return 0;
  const m = Math.max(...a.flatMap((t) => t.data.levels.map((s) => s.levelIndex)));
  if (e = a, m <= r)
    return 0;
  const n = Array(m - r).fill(0).map((t, s) => r + 1 + s);
  let l;
  i ? l = p(e, n, i) : l = p(e, n, e.map((t) => t.type));
  let f = 0;
  for (const t of l.values())
    f += o(t);
  return f;
};
export {
  y as getAboveLevelArea
};
//# sourceMappingURL=index.js.map
